import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { DimensionData, Dimensions } from '../elastic-element.directive';

@Injectable()
export class ElasticUIService {
    private readonly _elasticElements: BehaviorSubject<DimensionData[]> =
        new BehaviorSubject<DimensionData[]>([]);

    get elasticElements(): Observable<DimensionData[]> {
        return this._elasticElements.asObservable();
    }

    addDimensionSet(set: Dimensions, index?: number): number {
        let f = this._elasticElements.getValue();
        const newdim = {
            dimensions: set,
            index: index !== null ? index : f.length,
        };
        f.push(newdim);

        if (index === null) {
            f = this.reIndex(f);
        }

        this._elasticElements.next(f);
        return newdim.index;
    }

    updateElementSet(idx: number, dims: Dimensions): void {
        let s = this._elasticElements.getValue();
        s = s.map((x) => {
            if (x.index === idx) {
                x.dimensions = dims;
            }
            return x;
        });
        this._elasticElements.next(s);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    removeSet(idx: number) {
        let s = this._elasticElements.getValue();
        s = s.filter((g) => g.index !== idx);
        this._elasticElements.next(s);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    reIndex(s: DimensionData[]) {
        let idx = 0;
        return s.map((d) => {
            d.index = idx;
            idx++;
            return d;
        });
    }

    getElasticElementObservable(index: number): Observable<DimensionData> {
        const f = this._elasticElements.getValue();
        return of(f.find((h) => h.index === index));
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    destroy() {
        this._elasticElements.next([]);
    }
}
